<template>
  <div id="app" class="oo-module">
    <component :is="layout">
      <router-view />
    </component>
    <alert-modal></alert-modal>
  </div>
</template>

<script>
import { getStore } from "../src/api/services/storeService.js";
import ProgressIndicator from "./components/progressindicator";
import { mapMutations, mapActions } from "vuex";
import language from "vee-validate/dist/locale/en";
import store from "../src/store";
import AlertModal from './components/AlertModal.vue';

const default_layout = "default";
export default {
  components: {
    ProgressIndicator,
    AlertModal,
  },
  computed: {
    ...mapActions(["insertErrorlog", "redirectToErrorPage"]),
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout";
    }
  },
  props: {
    storeid: {
      type: String,
      default: ""
    },
    themeUrl: {
      type: String,
      default: ""
    },
    isgift: {
      type: Boolean,
      default: false
    },
    returnurl: {
      type: String,
      default: ""
    },
    noscroll: {
      type: Boolean,
      default: false
    },
    ishq: {
      type: Boolean,
      default: false,
    }
  },
  created() {
    if (this.returnurl) this.setMobileEmbededReturnUrl(this.returnurl);
    else this.setMobileEmbededReturnUrl("");
    let langStr = store.getters.selectedLocale;
    langStr = langStr.replace("-", "_");
    this.$validator.localize(langStr, {
      messages: language.messages
    });
    this.setStoreLoading();
    if (this.themeUrl && this.themeUrl != "") {
      var style = document.createElement("link");
      style.rel = "stylesheet";
      style.type = "text/css";
      style.setAttribute("OO_Attr", "OO_Module");
      style.href = this.themeUrl;
      document.head.appendChild(style);
    }
    if (this.storeid) {
      sessionStorage.setItem(
        "OOConfig",
        JSON.stringify({
          IsHQ: this.ishq,
          IsGift: this.isgift,
          ID: this.storeid,
          Name: this.storeid,
          NoScroll: this.noscroll,
        })
      );
      var that = this;
      getStore(this.storeid)
        .get()
        .then(doc => {
          if (doc.exists) {
            let storeDoc = doc.data();
            if (storeDoc.EmbeddedJavascript) {
              this.appendInnerHTML(document.head, storeDoc.EmbeddedJavascript);
            }
            sessionStorage.setItem(
              "OOConfig",
              JSON.stringify({
                IsHQ: storeDoc.IsHQ,
                IsGift: that.isgift,
                ID: storeDoc.ID,
                Name: storeDoc.Name,
                NoScroll: this.noscroll,
              })
            );
            // gift's pages have "gift" on their names
            if (
              that.isgift &&
              that.$route.name != null &&
              that.$route.name.indexOf("gift") < 0
            ) {
              that.$router.replace({
                name: "giftstore",
                params: {
                  storeid: storeDoc.ID,
                  storename: storeDoc.Name
                }
              });
            } else if (
              !that.isgift &&
              that.$route.name != null &&
              that.$route.name.indexOf("gift") >= 0
            ) {
              that.$router.replace({
                name: "store",
                params: {
                  storeid: storeDoc.ID,
                  storename: storeDoc.Name
                }
              });
            }
            if (storeDoc.IsHQ == false) {
              if (that.$route.name == "mainpage") {
                that.$router.replace({
                  name: "store",
                  params: {
                    storeid: storeDoc.ID,
                    storename: storeDoc.Name
                  }
                });
              }
            }
          }
        })
        .catch(reason => {
          this.insertErrorlog([
            reason.name,
            reason.toString(),
            this.$router.currentRoute.fullPath
          ]);
          this.redirectToErrorPage();
        });
    } else {
      sessionStorage.setItem("lockStore", JSON.stringify(null));
    }
    this.initHQDoc();
  },
  mounted() {
    let langStr = null;
    if (typeof store.getters.selectedLocale === "object") {
      langStr = store.getters.selectedLocale.locale;
    } else langStr = store.getters.selectedLocale;

    langStr = langStr.replace("-", "_");
    this.$validator.localize(langStr);
  },
  methods: {
    ...mapMutations(["setStoreLoading", "setMobileEmbededReturnUrl"]),
    ...mapActions(["initHQDoc"]),
    appendInnerHTML(elm, html) {
      elm.innerHTML = elm.innerHTML + html;
      Array.from(elm.querySelectorAll("script")).forEach( oldScript => {
        const newScript = document.createElement("script");
        Array.from(oldScript.attributes)
          .forEach( attr => newScript.setAttribute(attr.name, attr.value) );
        newScript.appendChild(document.createTextNode(oldScript.innerHTML));
        oldScript.parentNode.replaceChild(newScript, oldScript);
      });
    },
  }
};
</script>
